import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@freyr/freya-design-system/dist/src/css/freyads.min.css";
import './assets/scss/main.scss';
import { LicenseInfo } from "@mui/x-license-pro";
LicenseInfo.setLicenseKey("062f657f556edde694914e88f33116ffTz0xMDE4NzcsRT0xNzYzMjk2MDgyMDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y");
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
